module.exports = __webpack_public_path__ + "media/components/assets/dabang_bottle_03-008190bf13c10919e4544393c0e28f06.png";